export * from './minutes-input.component';
